import APIS from './apis.js';

/*xstream扩展*/
import * as xstream from 'xstream';
window.xstream = xstream;
var win = window,
    slice = Array.prototype.slice;

function loadScript(url, callback) {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.onload = function() {
        script.onload = null;
        callback();
    };

    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
};


var sdkResolve, // 暴露一个wx sdk load task的promise接口
    domReadyResolve, // 暴露一个DOMContentLoaded event的promise接口
    domReadyPr = new Promise(resolve => domReadyResolve = resolve);

win.domReadyPr = domReadyPr;
win.wxSDKLoadTask = new Promise(resolve => sdkResolve = resolve);

// var monitor = {
//         init() {
//             var i = 0,
//                 Stream = xstream.Stream;

//             Stream.fromArray(this.list)
//                 // 由于monitor.stat是同步函数，并往文档插入<script>，所以需要限频率
//                 .delayWhen(() => ++i % 4 ? Stream.of(0) : Stream.periodic(400).take(1))
//                 .addListener({
//                     next(params) {
//                         // console.log(win.monitor);
//                         win.monitor.stat.apply(win.monitor, params);
//                     }
//                 })
//         },
//         stat() {
//             this.list.push(slice.call(arguments));
//         },
//         list: []
//     };

// win.monitor = monitor;

// 将一些首屏无关的脚本加载延迟到DOMContentLoaded，甚至onload。
document.addEventListener("DOMContentLoaded", function() {
    domReadyResolve();
    if (/(?:MicroMessenger)/.test(navigator.userAgent)) {
        // 异步加载wxSDK
        loadScript('//res.wx.qq.com/open/js/jweixin-1.3.2.js', sdkResolve);
    }
    // 异步加载monitor.js，在此之前，提供一个monitor对象收集对window.monitor的调用。
    // 在monitor.js 就绪之后，重播收集到的信息。
    // setTimeout(function() {
    //     loadScript('//static.xinli001.com/frontend-lib/monitor.js', function() {
    //         // 配置monitor
    //         window.monitor.rootData.from = 'cp';
    //         monitor.init();
    //     });
    // }, 500);
});



// WEBPACK FOOTER //
// ./src/async-hack.js